export default "__VITE_ASSET__B6eFpcbD__"